import { useState } from 'react'
import { useMsal } from '@azure/msal-react'
import { authConfigured } from './msal'
import './UserMenu.css'

/**
 * Who is signed in, and the way out.
 *
 * The register records who changed what, so the person using it needs to be able
 * to see which identity their edits are being recorded against — on a shared site
 * machine that is not a detail. And a system with no visible sign-out is one
 * people leave signed in.
 */
export function UserMenu() {
  const { instance, accounts } = useMsal()
  const [open, setOpen] = useState(false)

  // A build with no Entra values runs against a DevAuth API, where the identity
  // is fixed and there is nothing to sign out of.
  if (!authConfigured) return null

  const account = accounts[0]
  if (!account) return null

  const label = account.name ?? account.username
  const initials = (label ?? '?')
    .split(/[\s.@]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')

  return (
    <div className="usermenu">
      <button
        type="button"
        className="usermenu__btn"
        onClick={() => setOpen((was) => !was)}
        aria-expanded={open}
        aria-haspopup="menu"
        title={account.username}
      >
        <span className="usermenu__avatar" aria-hidden="true">{initials}</span>
        <span className="usermenu__name">{label}</span>
      </button>

      {open && (
        <>
          {/* Click anywhere to dismiss, rather than trapping focus for a menu of one. */}
          <div className="usermenu__scrim" onClick={() => setOpen(false)} aria-hidden="true" />

          <div className="usermenu__panel" role="menu">
            <div className="usermenu__who">
              <b>{label}</b>
              {/* The full sign-in address, because it is what an administrator
                  asks for when someone reports a problem. */}
              <span className="mono">{account.username}</span>
            </div>

            <button
              type="button"
              role="menuitem"
              className="usermenu__signout"
              onClick={() => {
                setOpen(false)
                // Clears MSAL's cache and ends the Microsoft session too —
                // signing out of only the app leaves the next person one click
                // from being signed straight back in.
                void instance.logoutRedirect({
                  postLogoutRedirectUri: window.location.origin,
                })
              }}
            >
              Sign out
            </button>
          </div>
        </>
      )}
    </div>
  )
}
